// Shared drag-reorder helper. Extracted from Photoshoots.tsx (PX-313) once the
// carousel manager (PX-330) needed the same move-by-id logic — per the
// "two duplicates → extract" invariant.

// Move the item identified by `fromId` to where `toId` currently sits, returning
// a new array (no mutation). Returns the SAME reference when nothing moves so
// callers can early-out cheaply.
export function moveItem<T>(list: T[], fromId: string, toId: string, idOf: (x: T) => string): T[] {
  const from = list.findIndex((x) => idOf(x) === fromId)
  const to = list.findIndex((x) => idOf(x) === toId)
  if (from === -1 || to === -1 || from === to) return list
  const next = [...list]
  const [moved] = next.splice(from, 1)
  next.splice(to, 0, moved)
  return next
}
